import React from "react";
import styled from "styled-components";
import { GATSBY_URL } from "../../../config";
import useAxios from "axios-hooks";
import { API_URL } from "../../../config";

const StyledBioBox = styled.div`
  box-shadow: ${(props) => props.theme.boxShadow};
  background: white;
  .photoRow {
    display: grid;
    grid-template-columns: 70px auto;
    grid-column-gap: 2rem;
    align-items: center;
  }
  img {
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: 50%;
  }
`;

const BioBox = () => {
  const [{ data: programPage, loading: programPageLoading }] = useAxios(
    `${API_URL}/getProgramPage`
  );
  if (programPageLoading) return null;
  return (
    <StyledBioBox className="innerPadding">
      <a href={`${GATSBY_URL}/aboutus`}>
        <p>Instructor</p>
        <div className="photoRow">
          <img src={`${programPage.programHeadshot}?q=50&w=250`} alt="" />
          <div>Adam Lucero</div>
        </div>
        <p className="standardCopy">{programPage.programBio}</p>
      </a>
    </StyledBioBox>
  );
};

export default BioBox;
